export default {
  business: 'Business',
  'get-inspired': 'Laat je inspireren',
  'how-to': 'Hoe te',
  news: 'Nieuws',
  printstories: 'Printstories',
  highlights: 'Hoogtepunten',
  'business-growth': 'Bedrijfsgroei',
}
